export default __webpack_public_path__ + "static/media/fasting_headaches@3x.ada30edf.jpg";